module.exports = __webpack_public_path__ + "media/images/icon-product/bank-card-55cca2949e98d2ffc97643943b1a0c0d.svg";